import { render, staticRenderFns } from "./SmsMessageTemplates.vue?vue&type=template&id=6c65f415"
import script from "./SmsMessageTemplates.vue?vue&type=script&lang=js"
export * from "./SmsMessageTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c65f415')) {
      api.createRecord('6c65f415', component.options)
    } else {
      api.reload('6c65f415', component.options)
    }
    module.hot.accept("./SmsMessageTemplates.vue?vue&type=template&id=6c65f415", function () {
      api.rerender('6c65f415', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sms/SmsMessageTemplates.vue"
export default component.exports